'use client';
import { ClockIcon } from '@curology/ui-components-web/react/Icon/icons/ClockIcon';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

const ClockIconAndTimeEstimateCopy = () => {
  return (
    <div className="cur-flex cur-items-center cur-my-8">
      <ClockIcon className="cur-mr-2" size="sm" />
      <Typography className="cur-leading-6 cur-whitespace-pre-line">
        Takes approximately 4 min
      </Typography>
    </div>
  );
};

export default ClockIconAndTimeEstimateCopy;
